import Three from './Three'
import Box from './Box'
import Frame from './Frame'
import Size from './Size'
import Thick from './Thick'
import Face from './Face'
import Clog, { ClogFactory } from './Clog'

export default Three
export { Box, Frame, Size, Thick, Face, Clog, ClogFactory }



// WEBPACK FOOTER //
// ./src/app/pages/Order/Components/Three/index.ts